<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div class="wf-antialiased">
      <div class="wf-relative wf-pt-1">
        <div
          v-if="content.hasTitle"
          class="wf-flex wf-items-center wf-justify-between wf-mb-1"
        >
          <div
            class="focus:wf-outline-none wf-text-xs wf-font-semibold wf-inline-block wf-py-1 wf-px-2"
            :class="elementClasses(classes('textClasses'))"
            :style="elementStyles(styles('textStyles'))"
            contenteditable
            v-text="text"
            @input="text = $event.target.textContent"
          />
          <div
            class="text-right"
            :class="elementClasses(classes('textClasses'))"
          >{{ content.progressWidth }}%</div>
        </div>

        <div
          class="wf-overflow-hidden wf-h-4 wf-mb-4 wf-text-xs wf-flex"
          :class="elementClasses(classes('containerClasses'))"
          :style="elementStyles(styles('containerStyles'))"
        >
          <div
            class="wf-shadow-none wf-flex wf-items-center wf-flex-row wf-text-white wf-px-2 wf-whitespace-nowrap wf-justify-between"
            :style="elementStyles(styles('styles'))"
            :class="elementClasses(classes('classes'), classes('customClasses'))"
          >
            <div
              class="focus:wf-outline-none"
              v-if="! content.hasTitle"
              contenteditable
              v-text="content.text"
              @input="updateContentProperty('text', $event.target.textContent)"
            />
            <div v-if="! content.hasTitle">{{ content.progressWidth }}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditorComponent from "../contracts/EditorComponent";
export default EditorComponent.extend({
  computed: {
    containerId() {
      return this.$store.getters[`${this.module}/id`](this.element, 'container_id')
    },
  },
})
</script>

<style scoped>

</style>
